import "./header.css";
import Blog from "../../img/blog.jpg";

export default function Header() {
  return (
    <div className="header">
      <div className="headerTitles">
        <span className="headerTitleSm">Health & Fitness</span>
        <span className="headerTitleLg">BLOG</span>
      </div>
      <img
        className="headerImg"
        src={Blog}
        alt=""
      />
    </div>
  );
}
